import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { Quote } from '../types/quote.type';
import { QUOTES_API_PATHS } from '../constants/quotes-paths.constants';

type UseAcceptQuoteResult = {
  acceptQuote: (id: string) => Promise<Quote | null>;
  isSubmitting: boolean;
};

export function useAcceptQuote(): UseAcceptQuoteResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const acceptQuote = async (id: string): Promise<Quote | null> => {
    setIsSubmitting(true);

    try {
      // Backend reads the order owner from the quote's stored ownerId
      // (set at quote creation). No body fields are required from the frontend.
      const quote = await HttpClient.post<Quote>(QUOTES_API_PATHS.ACCEPT(id), {});

      enqueueSnackbar('Devis accepté, commande créée', { variant: 'success' });
      return quote;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, "Une erreur est survenue lors de l'acceptation du devis"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { acceptQuote, isSubmitting };
}
